export default __webpack_public_path__ + "static/media/rectangle2@3x.df36f4ad.png";